import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Wooden post with a hanging lantern — village path lighting (mesh only).
const build: (ctx: DecoBuildCtx) => void = ({ box, cylinder, seed }) => {
  const wood = shade(0x6b4a2b, (rand(seed) - 0.5) * 0.1);
  const iron = shade(0x3a3a40, (rand(seed + 1) - 0.5) * 0.06);
  const glass = shade(0xe8c86a, (rand(seed + 2) - 0.5) * 0.08);
  box(0, 1.15, 0, 0.16, 2.3, 0.16, wood);
  box(0.35, 2.15, 0, 0.7, 0.1, 0.1, wood);
  box(0.65, 2.0, 0, 0.08, 0.28, 0.08, iron);
  box(0.65, 1.78, 0, 0.28, 0.32, 0.28, iron);
  box(0.65, 1.78, 0, 0.22, 0.26, 0.22, glass);
  cylinder(0.65, 1.92, 0, 0.04, 0.04, 0.12, 0xf0d080);
  box(0.65, 1.98, 0, 0.32, 0.06, 0.32, iron);
};

export default build;
